import { defineComponent as _defineComponent } from 'vue'
import { StatusId } from '@/lib/enum';
import { omitString, formatToHtml } from '@/lib/formatter';
import { formatToDate } from '@/utils/datetime';
import { ReconfirmationSds } from '@/interfaces/api/general/sds';
import { defineMessages } from '@/lib/i18n';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsReconfirmationTable',
  props: {
    isLoading: { type: Boolean },
    safetyDataSheets: null,
    selectedSdses: null,
    isSelectedAllSdses: { type: Boolean },
    isSelectedIndeterminateSdses: { type: Boolean },
    total: null,
    page: null,
    itemsPerPage: null,
    activeSdsId: null
  },
  emits: ["showSdsDetail", "update:page", "update:itemsPerPage", "toggleSelectedSds", "toggleAllSelectedSdses", "toggleWholeSelectedSds", "fetchItems"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'showSdsDetail', item: ReconfirmationSds, index: number): void;
  (e: 'update:page', page: number): void;
  (e: 'update:itemsPerPage', itemsPerPage: number): void;
  (e: 'toggleSelectedSds', sds: ReconfirmationSds): void;
  (e: 'toggleAllSelectedSdses', checked: boolean): void;
  (e: 'toggleWholeSelectedSds'): void;
  (e: 'fetchItems'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isLoading: boolean;
  safetyDataSheets: ReconfirmationSds[];
  selectedSdses: ReconfirmationSds[];
  isSelectedAllSdses: boolean;
  isSelectedIndeterminateSdses: boolean;
  total: number;
  page: number;
  itemsPerPage: number;
  activeSdsId?: string;
};

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  userComment: 'ユーザーへの確認事項',
  commentDate: 'コメント日',
});

const headers = [
  { text: '', value: 'check', sortable: false },
  { text: $t(sharedMessages.pdfName), value: 'name', sortable: false },
  {
    text: $t(sharedMessages.analysis_status),
    value: 'status_id',
    sortable: false,
  },
  {
    text: $t(sharedMessages.pdfUploadDate),
    value: 'created_at',
    sortable: false,
  },
  {
    text: $t(sharedMessages.department),
    value: 'departments',
    sortable: false,
    width: '200px',
  },
  { text: $t(m.userComment), value: 'comment', sortable: false },
  { text: $t(m.commentDate), value: 'comment_created_at', sortable: false },
];

const footerProps = {
  'items-per-page-options': [50, 100, 200],
  'items-per-page-text': $t(sharedMessages.itemsPerPageText),
};





const isSelectedSds = (targetUuid: ReconfirmationSds['uuid']) =>
  props.selectedSdses.some((sds) => sds.uuid === targetUuid);

const isActiveSds = (uuid: string): boolean => {
  return uuid === props.activeSdsId;
};

return { __sfc: true,$t, m, headers, footerProps, props, emits, isSelectedSds, isActiveSds, StatusId, omitString, formatToHtml, formatToDate }
}

})